import React from 'react';
import { ts } from 'src/utils/translate';
import { MenuButtonText } from 'src/pages/OfferPage/DocuSectionButtons/MenuButtonText';
import { NewFeature } from 'src/pages/OfferPage/NewFeature/NewFeature';
import { OptionImage } from 'src/pages/OfferPage/DocuSectionButtons/OptionImage';
import { RootState, store } from 'src/app/store';
import { appApiSlice } from 'src/api/app-ApiSlice';
import { SectionButtonDescriptor } from 'src/pages/OfferPage/DocuSectionButtons/docuSectionButtonDefs';
import { ToggleSwitch } from 'src/pages/OfferPage/DocuSectionButtons/ToggleSwitch';
import { BTNS } from 'src/utils/constants';
import Tooltip from "@mui/material/Tooltip";

export const NormalOptionButton = ({buttonDesc}: { buttonDesc: SectionButtonDescriptor }) => {

  const btnRef = React.useRef<any>(null);

  const isPro = appApiSlice.endpoints.getVersion.select()(store.getState() as RootState).data!!.is_pro;

  const justProUser =
    !buttonDesc.enabled &&
      !isPro &&
    (buttonDesc.buttonId === BTNS.T_ARTICLENUMBERS);

  const reason =
      !buttonDesc.enabled
          ? (
            typeof buttonDesc.disableReason === "string" && buttonDesc.disableReason.length
              ? buttonDesc.disableReason
              : ts("q_not_found_in_current_project", "Not found in this project")
          ) : ""

  return (
      <Tooltip title={reason}>
        <div
          ref={btnRef}
          className={`quote-option-container ${justProUser ? "only-pro" : ""} ${
            buttonDesc.enabled ? "" : "disabled"
          }`}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            cursor: buttonDesc.enabled ? "pointer" : "not-allowed",
            flex: 1,
          }}
        >
          {justProUser ? <label className={"only-pro-label"}>PRO</label> : null}
          <OptionImage icon={buttonDesc.icon} isTest={buttonDesc.testFeature} />
          <MenuButtonText
            color={"black"}
            fontWeight={400}
            padding={"0 10px"}
            wordBreak={"break-word"}
            tooltip={buttonDesc.label}
          />
          <ToggleSwitch
              buttonDesc={buttonDesc}
              disableCursor={justProUser}
          />
          {buttonDesc.newFeature ? <NewFeature /> : null}
        </div>
      </Tooltip>
  );
};
